export function log(groupName?: string, style? : string) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const name = "%c" +(groupName ||  (target.constructor.name + ":" + propertyKey)); // Use provided name or method name
      if ( style ) console.style = style;      
      console.groupCollapsed(name, style);
      try {        
        const result = originalMethod.apply(this, args);
        return result;
      } finally {
        console.groupEnd();
        console.style = "";
      }
    };
    return descriptor;
  };
}

